import { GuestApprovalStatusCardController } from './guest-approval-status-card.controller'

const component = {
  templateUrl: '/guest/components/guest-approval-status-card/guest-approval-status-card.html?$$REVISION$$',
  bindings: {
    task: '<'
  },
  controllerAs: '$ctrl',
  controller: GuestApprovalStatusCardController
}

export const guestApprovalStatusCard = component
